import { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Button, TextInput } from 'sb-ui-components';
import { AuthenticationFormValues } from '../../models/authentication';
import { ResourceFormProps } from '../../types';
import './authentication-form.css';

const AuthenticationForm: FunctionComponent<ResourceFormProps> = props => {
  const { onSubmit } = props;
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm<AuthenticationFormValues>({ mode: 'onChange' });
  const { formatMessage } = useIntl();

  return (
    <form className="s-authentication-form" onSubmit={handleSubmit(onSubmit)}>
      <TextInput id="username" label={formatMessage({ id: 'label.email' })} register={register} type="email" />
      <TextInput id="password" type="password" label={formatMessage({ id: 'label.password' })} register={register} />
      <Button
        dataCy="cta__login"
        type="submit"
        size="big"
        className="s-authentication-form__button"
        disabled={isSubmitting}
      >
        {formatMessage({ id: 'button.login' })}
      </Button>
    </form>
  );
};
export default AuthenticationForm;
